// removed by extract-text-webpack-plugin
module.exports = {"survey-dropdown":"StudentSurveyListTable__survey-dropdown___1SyZV"};